<template>
  <div class="h-full overflow-hidden">
    <div class="flex flex-row-reverse flex-wrap mb-10px mr-10px">
      <el-button size="small" type="primary" @click="addOtherSecurityTrainingVisible = true"
        >上传</el-button
      >
    </div>
    <el-table
      :data="otherSecurityTrainingData"
      border
      stripe
      class="mt-20px"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column label="培训时间" prop="time" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ dayjs(scope.row.time).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="培训地点" prop="place" show-overflow-tooltip></el-table-column>
      <el-table-column label="培训人员" prop="memberNames" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.memberNames.join(',') }}
        </template>
      </el-table-column>
      <el-table-column label="培训内容" prop="content" show-overflow-tooltip></el-table-column>
      <el-table-column label="培训老师" prop="teacher" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEvent('read', scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="handleEvent('edit', scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleEvent('delete', scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="otherSecurityTrainingTableSizeChange"
      @current-change="otherSecurityTrainingableCurrentChange"
      :current-page.sync="otherSecurityTrainingPageConfig.SkipCount"
      :page-size.sync="otherSecurityTrainingPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="otherSecurityTrainingPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <AddOtherSecurityTraining
      v-model="addOtherSecurityTrainingVisible"
      :contractorId="contractorId"
      :saveOtherSecurityTraining="saveOtherSecurityTraining"
      :pageConfigType="pageConfigType"
    />
  </div>
</template>
<script>
import {
  WorkPermitAddtionalGuidanceConfigurationDirectoriesApi,
  ContractorApi,
} from '@wiz-api/contractor-management'
import AddOtherSecurityTraining from './addOtherSecurityTraining'

const contractorApi = new ContractorApi()
export default {
  components: {
    AddOtherSecurityTraining,
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pageConfigType: 'create',
      saveOtherSecurityTraining: {},
      loading: false,
      addOtherSecurityTrainingVisible: false,
      otherSecurityTrainingData: [],
      otherSecurityTrainingPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 108px)'
    },
  },
  watch: {
    addOtherSecurityTrainingVisible: {
      handler(val) {
        if (!val) {
          this.saveOtherSecurityTraining = {}
          this.pageConfigType = 'create'
          this.getData()
        }
      },
    },
  },
  created() {
    this.getData()
  },
  methods: {
    handleEvent(type, row) {
      if (type === 'edit' || type === 'read') {
        this.addOtherSecurityTrainingVisible = true
        this.pageConfigType = type
        this.saveOtherSecurityTraining = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteOtherSafetyTraining(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getData()
            }
          })
          .catch(() => {})
      }
    },
    // 奖励考核信息页码改变
    otherSecurityTrainingTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    otherSecurityTrainingableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      const data = {
        maxResultCount: this.otherSecurityTrainingPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.otherSecurityTrainingPageConfig.SkipCount - 1) *
          this.otherSecurityTrainingPageConfig.MaxResultCount, // 跳过多少条
      }
      this.loading = true
      const [err, res] = await contractorApi.getOtherSafetyTrainingsByPage(this.contractorId, data)
      if (!err) {
        this.otherSecurityTrainingData = res.items
        this.otherSecurityTrainingPageConfig.total = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>
